// extracted by mini-css-extract-plugin
export default {"TheFooter":"TheFooter_TheFooter__lu6xM","logo":"TheFooter_logo__1ZCC-","contacts":"TheFooter_contacts__V8jRV","social":"TheFooter_social__NGT4x"};